export default __webpack_public_path__ + "static/media/logo.4cd39a8d.svg";